import React, { FC } from 'react';
import styled from 'styled-components';

import AppModel from 'models/app';
import App from './App';

interface AppListProps {
  apps: AppModel[];
}

const AppsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
`;

const AppsList: FC<AppListProps> = ({
  apps
}) => (
  <AppsListContainer>
    {[...apps]
      .sort((app1, app2) => {
        let score1 = 0, score2 = 0;
        
        // apps with updates and permission warnings should be displayed at the top
        score1 -= app1.hasUpdateAvailable || app1.isInstalling ? 2 : 0;
        score1 -= app1.hasPermissionWarning ? 1 : 0;

        score2 -= app2.hasUpdateAvailable || app2.isInstalling ? 2 : 0;
        score2 -= app2.hasPermissionWarning ? 1 : 0;

        if (score1 === score2) {
          return app1.name.localeCompare(app2.name);
        }
        
        return score1 - score2;
      })
      .map(app => <App key={app.id} app={app} />)
    }
  </AppsListContainer>
);

export default AppsList;
